export const templateTags = [
  { key: 'dynamic', label: 'BNG_TAGS_DYNAMIC', selectedColor: '#3182c8' },
  { key: 'fun', label: 'BNG_TAGS_FUN', selectedColor: '#8b1079' },
  { key: 'playful', label: 'BNG_TAGS_PLAYFUL', selectedColor: '#faa030' },
  { key: 'modern', label: 'BNG_TAGS_MODERN', selectedColor: '#64d4d2' },
  { key: 'timeless', label: 'BNG_TAGS_TIMELESS', selectedColor: '#733ca6' },
  { key: 'creative', label: 'BNG_TAGS_CREATIVE', selectedColor: '#c164bd' },
  { key: 'techy', label: 'BNG_TAGS_TECHY', selectedColor: '#4eb7f5' },
  { key: 'fresh', label: 'BNG_TAGS_FRESH', selectedColor: '#65c888' },
  { key: 'formal', label: 'BNG_TAGS_FORMAL', selectedColor: '#f37e63' },
  { key: 'hipster', label: 'BNG_TAGS_HIPSTER', selectedColor: '#32babc' }
];

export const templateTagsWithLength = [...templateTags,
{ key: 'short', value: 'short' },
{ key: 'medium', value: 'medium' },
{ key: 'long', value: 'long' }];